<template>
  <div class="container-fluid main-color">
    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <h4 class="page-title">New Assessment Schedule</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->
    <div class="row">
      <div class="col-lg-12">
        <place-holder v-if="loading"></place-holder>
        <div class="card">
          <div v-if="!loading" class="card-body">
            <form class="parsley-examples">
              <div class="row">
                <div class="col-md-7">
                  <div class="row mb-3">
                    <label for="name" class="col-md-3 form-label">
                      Program Name
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-md-8">
                      <v-select
                       :disabled="currentRouteName === 'ojt-assessment-update'"
                        @option:selected="getSelectedProgram"
                        v-model="selectedProgram"
                        label="name"
                        :options="programs"
                        :clearable="false"
                        :class="{
                          'p-invalid':
                            v$.selectedProgram.$error || errorFor('name'),
                        }"
                      >
                      </v-select>
                      <v-errors
                        :serverErrors="errorFor('name')"
                        :vuelidateErrors="{
                          errors: v$.selectedProgram.$errors,
                          value: 'Program Name',
                        }"
                      ></v-errors>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <label for="short_name" class="col-md-3 form-label">
                      Batch
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-md-8">
                      <v-select
                      :disabled="currentRouteName === 'ojt-assessment-update'"
                        @option:selected="getSelectedBatch"
                        v-model="selectedBatch"
                        :selectable="(options) => isSelectable(options)"
                        label="batch_no"
                        :options="batch"
                        :clearable="false"
                        :class="{
                          'p-invalid':
                            v$.selectedBatch.$error || errorFor('name'),
                        }"
                      >
                      </v-select>
                      <v-errors
                        :serverErrors="errorFor('name')"
                        :vuelidateErrors="{
                          errors: v$.selectedBatch.$errors,
                          value: 'Batch',
                        }"
                      ></v-errors>
                    </div>
                  </div>

                  <div class="row mb-2">
                    <label for="level" class="col-md-3 form-label">
                      Level
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-md-8">
                      <v-select
                        v-model="schedule.level"
                        label="name"
                        :options="levels"
                        :reduce="(name) => name.name"
                        :clearable="false"
                        :class="{
                          'p-invalid':
                            v$.schedule.level.$error || errorFor('level'),
                        }"
                      >
                      </v-select>
                      <v-errors
                        :serverErrors="errorFor('name')"
                        :vuelidateErrors="{
                          errors: v$.schedule.level.$errors,
                          value: 'Level',
                        }"
                      ></v-errors>
                    </div>
                  </div>
                </div>

                <div class="row col-md-5">
                  <div class="row mb-2">
                    <label for="date" class="col-md-5 form-label">
                      From Date
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-md-6">
                      <flat-pickr
                        v-model="schedule.from_date"
                        class="form-control"
                        @on-change="
                          changeFromDate(schedule.from_date, schedule.to_date)
                        "
                        placeholder="Select From Date"
                        name="date"
                        :config="flatPickrDateConfig"
                      >
                      </flat-pickr>
                      <v-errors
                        :serverErrors="errorFor('date')"
                        :vuelidateErrors="{
                          errors: v$.schedule.from_date.$errors,
                          value: 'From Date',
                        }"
                      ></v-errors>
                    </div>
                  </div>
                  <div class="row mb-2">
                    <label for="date" class="col-md-5 form-label">
                      To Date
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-md-6">
                      <flat-pickr
                        v-model="schedule.to_date"
                        class="form-control"
                        @on-change="
                          changeToDate(schedule.from_date, schedule.to_date)
                        "
                        placeholder="Select To Date"
                        name="date"
                        :config="flatPickrDateConfig"
                      >
                      </flat-pickr>
                      <v-errors
                        :serverErrors="errorFor('date')"
                        :vuelidateErrors="{
                          errors: v$.schedule.to_date.$errors,
                          value: 'To Date',
                        }"
                      ></v-errors>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="float-end">
                                <button v-show="!loading" type="button" @click="addSchedule()"
                                    class="btn btn-sm btn-blue waves-effect waves-light mb-2">
                                    <i class="mdi mdi-plus-circle"></i> Add
                                </button>
                            </div> -->

              <div
                class="progress mt-5"
                style="height: 0.5px; background-color: #ccc !important"
              >
                <div class="progress-bar" role="progressbar"></div>
              </div>

              <div class="row mt-2 text-center" v-if="!loading">
                <div class="d-flex">
                  <div class="col-md-2">
                    <label for="name" class="form-label"> Employee Name </label>
                  </div>
                  <div class="col-md-1 me-3">
                    <label for="name" class="form-label"> Employee_Id </label>
                  </div>
                  <div class="col-md-2">
                    <label for="name" class="form-label">
                      Date
                      <span class="text-danger">*</span>
                    </label>
                  </div>
                  <div class="col-md-1">
                    <label for="name" class="form-label">
                      Time
                      <span class="text-danger">*</span>
                    </label>
                  </div>
                  <div class="col-md-2 me-2">
                    <label for="name" class="form-label">
                      Assessor
                      <span class="text-danger">*</span>
                    </label>
                  </div>
                  <div class="col-md-2">
                    <label for="name" class="form-label">
                      Assessment Location
                      <span class="text-danger">*</span>
                    </label>
                  </div>
                  <div class="col-md-1">
                    <label for="name" class="form-label">
                      Remark
                      <span class="text-danger">*</span>
                    </label>
                  </div>
                </div>
              </div>

              <div v-if="!loading">
                <div class="row mb-4" v-if="employeeLists">
                  <div
                    v-for="(item, index) in schedule.assessment_details"
                    :key="index"
                    class="d-flex m-2"
                  >
                    <div class="col-md-2 me-1">
                      <span>{{ item.employee?.name }}</span>
                    </div>
                    <div class="col-md-1 me-1">
                      <span>{{ item.employee_id }}</span>
                    </div>
                    <div class="col-md-2 me-1">
                      <flat-pickr
                        v-model="item.date"
                        class="form-control"
                        placeholder="Select Date"
                        name="date"
                        :config="flatPickrDateConfigLimit"
                      ></flat-pickr>
                    </div>
                    <div class="col-md-1 me-1">
                      <flat-pickr
                        v-model="item.time"
                        class="form-control"
                        placeholder="Select Time"
                        name="time"
                        :config="flatPickrTimeConfig"
                      ></flat-pickr>
                    </div>
                    <div class="col-md-2 me-1">
                      <v-select
                        v-model="item.assessor_employee_id"
                        label="name"
                        :options="assessor"
                        :reduce="(name) => name.id"
                        :clearable="false"
                      >
                      </v-select>
                    </div>
                    <div class="col-md-2 me-1">
                      <input
                        type="text"
                        id="assessment_location"
                        name="assessment_location"
                        class="form-control"
                        placeholder="Location"
                        v-model="item.assessment_location"
                      />
                    </div>
                    <div class="col-md-1 me-1">
                      <input
                        type="text"
                        id="remark"
                        name="remark"
                        class="form-control"
                        placeholder="Remark"
                        v-model="item.remark"
                      />
                    </div>
                    <div class="col-md-1" v-show="index != 0">
                      <div v-show="!loading" @click="removeSchedule(index)">
                        <i class="fas fa-trash-alt mx-1"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end row -->
              <div class="row">
                <div class="col-md-12">
                  <div class="text-center mt-3 mb-3">
                    <router-link :to="{ name: 'ojt-assessment' }">
                      <button type="button" class="btn w-sm btn-secondary me-5">
                        Cancel
                      </button>
                    </router-link>
                    <button
                      v-if="
                        schedule.assessment_details == '' ||
                        schedule.assessment_details == []
                      "
                      type="button"
                      class="btn w-sm btn-success waves-effect waves-light px-3"
                      style="cursor: not-allowed"
                      data-bs-toggle="tooltip"
                      title="Data is nothing to save!"
                    >
                      Save
                    </button>
                    <button
                      v-else
                      :disabled="isLoading ? true : false"
                      type="button"
                      class="btn w-sm btn-success waves-effect waves-light px-3"
                      @click="
                        currentRouteName === 'ojt-assessment-update'
                          ? updateSchedule()
                          : createSchedule()
                      "
                    >
                      <span
                        v-if="isLoading"
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      {{ isLoading == true ? "Loading..." : "Save" }}
                    </button>
                  </div>
                </div>
                <!-- end col -->
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { useToast } from "vue-toastification";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import validationErrors from "../../../mixins/validationErrors";

export default {
  setup() {
    const toast = useToast();
    return { v$: useVuelidate(), toast };
  },
  components: {
    vSelect,
    flatPickr,
  },
  mixins: [validationErrors],
  data() {
    return {
      assessmentList: [],
      programs: this.$store.getters["odoo/getAllPrograms"],
      batch: [],
      levels: [],
      employeeLists: [],
      assessor: [],
      flatPickrDateConfig: {
        minDate: null,
        maxDate: null,
        defaultDate: null,
      },
      flatPickrDateConfigLimit: {
        minDate: null,
        maxDate: null,
        defaultDate: null,
      },
      flatPickrTimeConfig: {
        enableTime: true,
        noCalendar: true,
        defaultTime: "08:00:00",
        dateFormat: "H:i:s",
        altInput: true,
        altFormat: "H:i",
        minTime: "08:00",
        maxTime: "17:00",
      },
      schedule: {
        type: "OJT",
        program_id: "",
        program: {
          id: "",
          name: "",
          code: "",
        },
        batch_id: "",
        batch: {
          id: "",
          batch_no: "",
        },
        level: "",
        from_date: "",
        to_date: "",
        assessment_details: [
          {
            employee: {
              name: "",
              employee_id: "",
            },
            employee_id: "",
            date: "",
            time: "",
            assessor_employee_id: "",
            assessment_location: "",
            remark: "",
          },
        ],
      },
      oldScheduleDatas: [],
      selectedProgram: null,
      selectedBatch: null,
      baseUrl: process.env.VUE_APP_BASE_URL,
      //  
      loading: false,
      isLoading: false,
    };
  },
  validations() {
    return {
      selectedProgram: { required },
      selectedBatch: { required },
      schedule: {
        program_id: { required },
        program: {
          id: { required },
          name: { required },
          code: { required },
        },
        batch_id: { required },
        batch: {
          id: { required },
          batch_no: { required },
        },
        level: { required },
        from_date: { required },
        to_date: { required },
      },
    };
  },
  methods: {
    // addSchedule() {
    //     this.schedule.assessment_details.push({
    //         employee_name: "",
    //         employee_id: "",
    //         date: "",
    //         time: "",
    //         assessor_employee_id: "",
    //         remark: ""
    //     })
    // },
    removeSchedule(index) {
      this.schedule.assessment_details.splice(index, 1);
    },
    getSelectedProgram() {
      if (this.selectedProgram) {
        this.schedule.program_id = this.selectedProgram.id;
        this.schedule.program.id = this.selectedProgram.id;
        this.schedule.program.name = this.selectedProgram.name;
        this.schedule.program.code = this.selectedProgram.short_name;
        this.getBatchByProgram(this.schedule.program_id);
        this.selectedBatch = null;
      }
    },
    getSelectedBatch() {
      if (this.selectedBatch) {
        this.schedule.batch_id = this.selectedBatch.id;
        this.schedule.batch.id = this.selectedBatch.id;
        this.schedule.batch.batch_no = this.selectedBatch.batch_no;

        this.schedule.assessment_details = [];
        this.employeeLists = [];
        // console.log('claer');   

        this.getEmployeeByBatch(this.schedule.batch_id);
      }
    },
    async getBatchByProgram(program_id) {
      this.loading = true;
      await axios
        .get(
          `${this.baseUrl}admin/v1/program-batches/list/?program_id=${program_id}`
        )
        .then((response) => {
          this.batch = response.data.data;
          this.loading = false;
        })
        .catch(() => {
          this.toast.error("Not Found Batch!");
        });
    },
    async getEmployeeByBatch(batch_id) {
      
      this.loading = true;
      await axios
        .get(`${this.baseUrl}admin/v1/program-batch/employees/list/${batch_id}`)
        .then((response) => {
          this.employeeLists = response?.data?.data?.employee_ids;

          const isCreateRoute = this.currentRouteName === "ojt-assessment-create"
          const employees_list = isCreateRoute ? this.employeeLists?.filter(emp => emp?.employee?.active) : this.employeeLists

          employees_list?.forEach((item) => {
            // Check if employee_id already exists in assessment_details
            const employeeExists = this.schedule.assessment_details.some(
              (element) => element.employee_id === item.employee?.emp_id
            );
            // If not present, add the employee details
            if (!employeeExists && item?.employee?.active) {
              this.schedule.assessment_details.push({
                // id: 0, //cuz we need to send id to backend to check existed emp
                employee: item.employee,
                employee_id: item.employee.emp_id,
                date: "",
                time: "",
                assessor_employee_id: "",
                assessment_location: "",
                remark: "",
              });
            }
          });

          this.loading = false;
        })
        .catch(() => {
          this.toast.error("Not Found Employee!");
        });
    },

    async getAllLevels() {
      this.loading = true;
      this.$Progress.start();
      await axios.get(`${this.baseUrl}admin/v1/levels`).then((response) => {
        this.levels = response.data.data;
        this.loading = false;
        this.$Progress.finish();
      });
    },

    changeFromDate(from_date, to_date) {
      this.schedule.from_date = from_date;
      this.schedule.to_date = to_date;

      if (this.schedule.to_date) {
        if (this.schedule.from_date > this.schedule.to_date) {
          this.toast.error("To Date Is Smaller Than From Date!");
        }
      }

      this.flatPickrDateConfigLimit.minDate = this.schedule.from_date;
      this.flatPickrDateConfigLimit.maxDate = this.schedule.to_date;
    },

    changeToDate(from_date, to_date) {
      this.schedule.from_date = from_date;
      this.schedule.to_date = to_date;

      if (this.schedule.from_date > this.schedule.to_date) {
        this.toast.error("To Date Is Smaller Than From Date!");
      }

      this.flatPickrDateConfigLimit.minDate = this.schedule.from_date;
      this.flatPickrDateConfigLimit.maxDate = this.schedule.to_date;
    },

    async getHRDemployee() {

      this.assessor = this.$store.getters["odoo/getAllEmployees"].map((item) => {
        return {
          id: item.emp_id,
          name: item.name,
        };
      });
    },

    async getAllocationById() {
      this.loading = true;
      await axios
        .get(
          `${this.baseUrl}admin/v2/assessment-schedule/${this.$route.params.id}`
        )
        .then((response) => {
          const result = response.data.data;
          this.schedule = result;
          this.selectedProgram = {
            id: result.program.id,
            name: result.program.name,
            short_name: result.program.code,
          };
          this.selectedBatch = {
            id: result.batch.id,
            batch_no: result.batch.batch_no,
          };
          this.schedule.assessment_details = result.assessment_details.map(
            (item) => {
              return {
                id: item.id,
                employee: item.employee,
                employee_id: item.employee_id,
                date: item.date,
                time: item.time,
                assessor_employee_id: item.assessor_employee_id,
                assessment_location: item.assessment_location,
                remark: item.remark,
              };
            }
          );
          this.flatPickrDateConfigLimit.minDate = result.from_date;
          this.flatPickrDateConfigLimit.maxDate = result.to_date;

          this.flatPickrDateConfig.minDate = result.from_date;
          this.flatPickrDateConfig.maxDate = result.to_date;

          this.getBatchByProgram(this.selectedProgram.id);
          this.getEmployeeByBatch(this.selectedBatch.id);
        })
        .catch(() => {
          this.toast.error("Not Found Data!");
        });
      this.loading = false;
    },

    checkEmptyValue(array) {
      delete array.remark;
      let scheduleData = Object.values(array);
      if (scheduleData.includes(null) || scheduleData.includes("")) {
        return false;
      } else {
        return true;
      }
    },

    async createSchedule() {
      const isFormCorrect = await this.v$.$validate();
      if (!isFormCorrect) return;

      if (this.schedule.from_date > this.schedule.to_date) {
        this.toast.error("To Date Is Smaller Than From Date!");
        return;
      }

      let checkSchedule = [];

      this.schedule.assessment_details.forEach((array) => {
        let remarkValue = array.remark;
        let schedule_data = this.checkEmptyValue(array);
        array.remark = remarkValue;
        checkSchedule.push(schedule_data);
      });
      
      if (checkSchedule.includes(false)) {
        this.toast.error("Please Fill All Input!");
        return;
      }

      this.isLoading = true;

      let data = {
        type: this.schedule.type,
        program_id: this.schedule.program_id,
        batch_id: this.schedule.batch_id,
        level: this.schedule.level,
        from_date: this.schedule.from_date,
        to_date: this.schedule.to_date,
        assessment_details: this.schedule.assessment_details.map((item) => {
          return {
            employee_id: item.employee.emp_id,
            date: item.date,
            time: item.time,
            assessor_employee_id: item.assessor_employee_id,
            remark: item.remark,
            assessment_location: item.assessment_location,
          };
        }),
      };
      await axios
        .post(`${this.baseUrl}admin/v2/assessment-schedule`, data)
        .then(() => {
          this.$router.push({ name: "ojt-assessment" });
          this.toast.success("Successfully Created Schedule!");
          this.isLoading = false;
        })
        .catch((error) => {
          this.errors = error.response;
          this.toast.error("Something Went Wrong!");
          this.isLoading = false;
        });
    },

    async getOldScheduleDatas() {
      this.schedule.assessment_details = this.oldScheduleDatas;
    },

    isSelectable(options){
      // return !this.assessmentList.some(
      //           (item) => item.batch.batch_no === options.batch_no
      //       );

            return this.assessmentList;
    },

    async getAssessments(){
      await axios
        .get(`${this.baseUrl}admin/v2/assessment-schedule?type=OJT`)
        .then((response) => {
            this.assessmentList = response.data.data;
            this.loading = false;
            this.$Progress.finish();
        })
        .catch((error) => {
            this.errors = error.response.data.errors;
            this.toast.error("Something Went Wrong!");
        });
    },

    async updateSchedule() {
      const isFormCorrect = await this.v$.$validate();
      if (!isFormCorrect) return;

      if (this.schedule.from_date > this.schedule.to_date) {
        this.toast.error("To Date Is Smaller Than From Date!");
        return;
      }

      let checkSchedule = [];

      this.schedule.assessment_details.forEach((array) => {
        let remarkValue = array.remark;
        let schedule_data = this.checkEmptyValue(array);
        array.remark = remarkValue;
        checkSchedule.push(schedule_data);
      });
      
      if (checkSchedule.includes(false)) {
        this.toast.error("Please Fill All Input!");
        return;
      }

      let data = {
        type: "OJT",
        program_id: this.schedule.program_id,
        program: this.schedule.program,
        batch_id: this.schedule.batch_id,
        batch: this.schedule.batch,
        level: this.schedule.level,
        from_date: this.schedule.from_date,
        to_date: this.schedule.to_date,
        assessment_details: this.schedule.assessment_details.map((item) => {
          return {
            id: item.id,
            employee_id: item.employee.emp_id,
            date: item.date,
            time: item.time,
            assessor_employee_id: item.assessor_employee_id,
            remark: item.remark,
            assessment_location: item.assessment_location,
          };
        }),
      };
      this.isLoading = true;
      axios
        .put(
          `${this.baseUrl}admin/v2/assessment-schedule/${this.$route.params.id}`,
          data
        )
        .then(() => {
          this.$router.push({ name: "ojt-assessment" });
          this.toast.success("Successfully Schedule Updated!");
          this.isLoading = false;
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          this.toast.error("Something Went Wrong!");
          this.isLoading = false;
        });
    },
  },
  async created() {
    await this.getAssessments();
    this.getAllLevels();
    this.getHRDemployee();
    this.getOldScheduleDatas();
    if (this.currentRouteName == "ojt-assessment-update") {
      this.getAllocationById();
    }
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
};
</script>

<style>
.custom-selectCSS {
  --vs-dropdown-min-width: 160px;
  --vs-dropdown-max-height: 200px;
}
</style>
